<template>
  <div class="paintings">
    <navigation></navigation>
    <!-- Circle Preloader -->
    <h3 class="headlink">
      <router-link to="/installation">Installation</router-link> / Heaven 67
    </h3>
    <div class="container">
      <div class="card-columns">
        <div class="card border-0 p-4">
          <img
            v-img
            class="card-img-top rounded-0 "
            src="@/assets/images/installation/Heaven67/ExhibitionView1.jpg"
            alt="Card image cap"
          />
          <div class="card-body">
            <p class="card-text small text-right">
              <i>Exhibition View 1</i><br />
            </p>
          </div>
        </div>
        <div class="card border-0 p-4">
          <img
            v-img
            class="card-img-top rounded-0 "
            src="@/assets/images/installation/Heaven67/ExhibitionView2.jpg"
            alt="Card image cap"
          />
          <div class="card-body">
            <p class="card-text small text-right">
              <i>Exhibition View 2</i><br />
            </p>
          </div>
        </div>
        <div class="card border-0 p-4">
          <img
            v-img
            class="card-img-top rounded-0 "
            src="@/assets/images/installation/Heaven67/ExhibitionView3.jpg"
            alt="Card image cap"
          />
          <div class="card-body">
            <p class="card-text small text-right">
              <i>Exhibition View 3</i><br />
            </p>
          </div>
        </div>
        <!-- end row 1 -->
        <div class="card border-0 p-4">
          <img
            v-img
            class="card-img-top rounded-0 "
            src="@/assets/images/installation/Heaven67/ExhibitionView4.jpg"
            alt="Card image cap"
          />
          <div class="card-body">
            <p class="card-text small text-right">
              <i>Exhibition View 4</i><br />
            </p>
          </div>
        </div>

        <!-- end row 2 -->
      </div>
      <!-- -->
    </div>

    <!--container end div-->
    <back-to-top bottom="20px" right="20px">
      <button type="button" class="btn btn-light btn-to-top">
        <i class="fa fa-chevron-up"></i>
      </button>
    </back-to-top>
  </div>
</template>

<script>
import navigation from "@/components/navigation.vue";

export default {
  components: {
    navigation,
  },
  data() {
    return {};
  },
  methods: {},
};
</script>

<style lang="scss">
@import "./../sass/_main.scss";
</style>
